/** Hand-drawn SVG art for the language easter eggs. Every piece is original vector art. */

export type ArtId =
  | 'tube' | 'sputnik' | 'dog' | 'pennant'
  | 'footprint' | 'helmet' | 'telescope'
  | 'pretzel' | 'retro' | 'orbits'
  | 'star' | 'windmill' | 'churro'
  | 'rabbit' | 'redlantern' | 'mooncake'
  | 'khomloi' | 'bangfai' | 'lotus'

export function EggArt({ id }: { id: ArtId }) {
  switch (id) {
    case 'tube':
      return (
        <svg viewBox="0 0 64 64">
          <path d="M20 10 h24 l-3 36 h-18 z" fill="#dfe4ea" stroke="#8b96a8" strokeWidth="1.5" />
          <rect x="22" y="22" width="20" height="12" rx="2" fill="#c0392b" />
          <text x="32" y="30.5" textAnchor="middle" fontSize="7" fontWeight="800" fill="#fff" fontFamily="Manrope, Arial">БОРЩ</text>
          <rect x="26" y="46" width="12" height="6" fill="#8b96a8" /><rect x="28" y="52" width="8" height="6" rx="1.5" fill="#4a5568" />
          <path d="M20 10 h24 v3 h-24 z" fill="#8b96a8" />
        </svg>
      )
    case 'sputnik':
      return (
        <svg viewBox="0 0 64 64">
          <defs><radialGradient id="ea-sp" cx="0.35" cy="0.3"><stop offset="0" stopColor="#ffffff" /><stop offset="0.5" stopColor="#c9d1dc" /><stop offset="1" stopColor="#6f7a8a" /></radialGradient></defs>
          {[[26, 30, 4, 60], [28, 34, 10, 62], [36, 34, 54, 62], [38, 30, 62, 58]].map(([x1, y1, x2, y2]) => <line key={x2} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#c9d1dc" strokeWidth="1.6" />)}
          <circle cx="32" cy="24" r="14" fill="url(#ea-sp)" />
          <path d="M18 24 h28" stroke="#8b96a8" strokeWidth="1" />
        </svg>
      )
    case 'dog':
      return (
        <svg viewBox="0 0 64 64">
          <circle cx="32" cy="32" r="24" fill="rgba(180,220,255,.18)" stroke="#dfe8f2" strokeWidth="2.5" />
          <path d="M20 26 q-2 -12 6 -10 l2 8 M44 26 q2 -12 -6 -10 l-2 8" fill="#f4efe6" stroke="#b9a58c" strokeWidth="1" />
          <ellipse cx="32" cy="34" rx="12" ry="11" fill="#f4efe6" />
          <ellipse cx="32" cy="40" rx="6" ry="4" fill="#fff" />
          <circle cx="27" cy="31" r="1.8" fill="#222" /><circle cx="37" cy="31" r="1.8" fill="#222" />
          <ellipse cx="32" cy="37" rx="2.4" ry="1.7" fill="#222" />
          <path d="M22 50 h20" stroke="#c0392b" strokeWidth="3" strokeLinecap="round" />
        </svg>
      )
    case 'pennant':
      return (
        <svg viewBox="0 0 64 64">
          <line x1="14" y1="6" x2="14" y2="60" stroke="#c9d1dc" strokeWidth="2.5" />
          <path d="M15 8 h36 l-8 12 l8 12 h-36 z" fill="#1d6fd1" />
          <text x="31" y="23.5" textAnchor="middle" fontSize="7.5" fontWeight="800" fill="#fff" fontFamily="Manrope, Arial">ПОЕХАЛИ</text>
        </svg>
      )
    case 'footprint':
      return (
        <svg viewBox="0 0 64 64">
          <ellipse cx="32" cy="34" rx="15" ry="24" fill="rgba(200,210,225,.15)" stroke="#c9d4e6" strokeWidth="2" />
          {[16, 24, 32, 40, 48].map((y) => <line key={y} x1="19" y1={y} x2="45" y2={y} stroke="#c9d4e6" strokeWidth="2.4" />)}
        </svg>
      )
    case 'helmet':
      return (
        <svg viewBox="0 0 64 64">
          <defs><linearGradient id="ea-visor" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#ffd28a" /><stop offset="0.5" stopColor="#b86b2c" /><stop offset="1" stopColor="#3a1f10" /></linearGradient></defs>
          <path d="M10 40 a22 22 0 0 1 44 0 v8 h-44 z" fill="#f2f4f7" stroke="#9aa4b2" strokeWidth="1.5" />
          <path d="M16 38 a16 14 0 0 1 32 0 v2 h-32 z" fill="url(#ea-visor)" />
          <rect x="8" y="48" width="48" height="8" rx="3" fill="#c9d1dc" />
          <path d="M22 28 q6 -6 12 -4" stroke="#fff" strokeWidth="2" fill="none" opacity=".8" />
        </svg>
      )
    case 'telescope':
      return (
        <svg viewBox="0 0 64 64">
          <rect x="18" y="20" width="28" height="22" rx="3" fill="#c9d1dc" stroke="#8b96a8" />
          <rect x="20" y="16" width="24" height="6" fill="#8b96a8" />
          <circle cx="32" cy="31" r="7" fill="#1b2330" stroke="#6f7a8a" strokeWidth="2" />
          <rect x="2" y="26" width="16" height="10" fill="#1d3a8a" stroke="#7cc8ff" strokeWidth="1" />
          <rect x="46" y="26" width="16" height="10" fill="#1d3a8a" stroke="#7cc8ff" strokeWidth="1" />
        </svg>
      )
    case 'pretzel':
      return (
        <svg viewBox="0 0 64 64">
          <path d="M32 50 C 8 50, 8 16, 24 16 C 34 16, 36 30, 32 36 C 28 30, 30 16, 40 16 C 56 16, 56 50, 32 50 Z M20 44 L44 26 M44 44 L20 26" fill="none" stroke="#b36a2e" strokeWidth="6" strokeLinecap="round" />
          {[[22, 22], [42, 22], [32, 45], [16, 34], [48, 34]].map(([x, y]) => <circle key={`${x}${y}`} cx={x} cy={y} r="1.4" fill="#fff" />)}
        </svg>
      )
    case 'retro':
      return (
        <svg viewBox="0 0 64 64">
          <path d="M32 4 C 44 16, 44 36, 40 48 H 24 C 20 36, 20 16, 32 4 Z" fill="#e8e2d4" stroke="#8b7f6a" strokeWidth="1.5" />
          <path d="M24 38 L14 52 H24 Z M40 38 L50 52 H40 Z" fill="#c0392b" />
          <circle cx="32" cy="24" r="5" fill="#7cc8ff" stroke="#8b7f6a" strokeWidth="1.5" />
          <path d="M26 50 q6 12 12 0" fill="#ffb347" />
        </svg>
      )
    case 'orbits':
      return (
        <svg viewBox="0 0 64 64">
          <circle cx="32" cy="32" r="6" fill="#ffd28a" />
          <ellipse cx="32" cy="32" rx="26" ry="12" fill="none" stroke="#7cc8ff" strokeWidth="1.5" />
          <ellipse cx="32" cy="32" rx="18" ry="8" fill="none" stroke="#a99bff" strokeWidth="1.5" transform="rotate(30 32 32)" />
          <circle cx="58" cy="32" r="3" fill="#7cc8ff" /><circle cx="44" cy="23" r="2.4" fill="#a99bff" />
        </svg>
      )
    case 'star':
      return (
        <svg viewBox="0 0 64 64">
          <defs><linearGradient id="ea-tail" x1="0" y1="1" x2="1" y2="0"><stop offset="0" stopColor="#ffd28a" stopOpacity="0" /><stop offset="1" stopColor="#fff3c4" /></linearGradient></defs>
          <path d="M4 58 L40 24" stroke="url(#ea-tail)" strokeWidth="5" strokeLinecap="round" />
          <path d="M46 8 l4 9 10 1 -8 6 3 10 -9 -6 -9 6 3 -10 -8 -6 10 -1 z" fill="#ffe08a" />
        </svg>
      )
    case 'windmill':
      return (
        <svg viewBox="0 0 64 64">
          <path d="M26 60 L28 28 H36 L38 60 Z" fill="#f2ede2" stroke="#8b7f6a" />
          <path d="M26 30 L32 20 L38 30 Z" fill="#8b4a2b" />
          <g className="ea-spin" style={{ transformOrigin: '32px 26px' }}>
            {[0, 90, 180, 270].map((angle) => <rect key={angle} x="31" y="4" width="4" height="22" fill="#c9b27a" stroke="#6b5a3a" strokeWidth=".8" transform={`rotate(${angle} 32 26)`} />)}
          </g>
          <circle cx="32" cy="26" r="2.5" fill="#6b5a3a" />
        </svg>
      )
    case 'churro':
      return (
        <svg viewBox="0 0 64 64">
          <path d="M14 50 C 20 30, 40 18, 52 12" stroke="#c98a3a" strokeWidth="10" strokeLinecap="round" fill="none" />
          <path d="M14 50 C 20 30, 40 18, 52 12" stroke="#e8b060" strokeWidth="3" strokeDasharray="3 4" strokeLinecap="round" fill="none" />
          {[[22, 36], [32, 26], [42, 18], [18, 44]].map(([x, y]) => <circle key={`${x}`} cx={x} cy={y} r="1.3" fill="#fff" />)}
        </svg>
      )
    case 'rabbit':
      return (
        <svg viewBox="0 0 64 64">
          <ellipse cx="34" cy="42" rx="16" ry="12" fill="#f4f1ea" />
          <circle cx="20" cy="32" r="9" fill="#f4f1ea" />
          <ellipse cx="16" cy="16" rx="3.5" ry="11" fill="#f4f1ea" transform="rotate(-12 16 16)" />
          <ellipse cx="23" cy="15" rx="3.5" ry="11" fill="#f4f1ea" transform="rotate(10 23 15)" />
          <ellipse cx="23" cy="15" rx="1.6" ry="7" fill="#f3b6c2" transform="rotate(10 23 15)" />
          <circle cx="17" cy="31" r="1.6" fill="#c0392b" />
          <circle cx="50" cy="40" r="4" fill="#f4f1ea" />
        </svg>
      )
    case 'redlantern':
      return (
        <svg viewBox="0 0 64 64">
          <line x1="32" y1="2" x2="32" y2="10" stroke="#d9a93d" strokeWidth="2" />
          <rect x="24" y="9" width="16" height="4" rx="1" fill="#d9a93d" />
          <ellipse cx="32" cy="32" rx="20" ry="18" fill="#d6312b" />
          {[-12, -4, 4, 12].map((dx) => <path key={dx} d={`M${32 + dx} 14 Q ${32 + dx * 1.6} 32 ${32 + dx} 50`} stroke="#a3221d" strokeWidth="1.2" fill="none" />)}
          <rect x="24" y="49" width="16" height="4" rx="1" fill="#d9a93d" />
          <path d="M30 53 v9 M32 53 v10 M34 53 v9" stroke="#d9a93d" strokeWidth="1.5" />
          <text x="32" y="37" textAnchor="middle" fontSize="13" fill="#ffd28a" fontWeight="700">福</text>
        </svg>
      )
    case 'mooncake':
      return (
        <svg viewBox="0 0 64 64">
          <circle cx="32" cy="34" r="24" fill="#b87a3a" />
          <circle cx="32" cy="32" r="22" fill="#d49a52" />
          {Array.from({ length: 12 }, (_, index) => <circle key={index} cx={32 + Math.cos((index / 12) * Math.PI * 2) * 19} cy={32 + Math.sin((index / 12) * Math.PI * 2) * 19} r="3.2" fill="#c98a42" />)}
          <circle cx="32" cy="32" r="12" fill="none" stroke="#a8692c" strokeWidth="2" />
          <text x="32" y="37" textAnchor="middle" fontSize="13" fill="#8a5220" fontWeight="700">月</text>
        </svg>
      )
    case 'khomloi':
      return (
        <svg viewBox="0 0 64 64">
          <defs><radialGradient id="ea-kl" cx="0.5" cy="0.45"><stop offset="0" stopColor="#fff3c4" /><stop offset="0.55" stopColor="#ffb347" /><stop offset="1" stopColor="#d9652b" /></radialGradient></defs>
          <path d="M18 12 Q32 4 46 12 L42 48 Q32 52 22 48 Z" fill="url(#ea-kl)" />
          <path d="M22 48 Q32 52 42 48" fill="none" stroke="#8a3b12" strokeWidth="2" />
          <circle cx="32" cy="52" r="3.5" fill="#fff3c4" />
        </svg>
      )
    case 'bangfai':
      return (
        <svg viewBox="0 0 64 64">
          <path d="M28 6 L36 6 L36 44 L28 44 Z" fill="#d6312b" stroke="#8a1d18" />
          <path d="M28 6 L32 0 L36 6 Z" fill="#d9a93d" />
          {[12, 20, 28, 36].map((y) => <rect key={y} x="28" y={y} width="8" height="2" fill="#d9a93d" />)}
          <path d="M32 44 L32 64" stroke="#8b6a3a" strokeWidth="2" />
          <path d="M26 46 q6 14 12 0" fill="#ffb347" opacity=".9" />
        </svg>
      )
    default:
      return (
        <svg viewBox="0 0 64 64">
          {[-50, -25, 0, 25, 50].map((angle) => <ellipse key={angle} cx="32" cy="28" rx="7" ry="18" fill={angle === 0 ? '#ffc2d6' : '#ff9ec0'} stroke="#d45d8a" strokeWidth="1" transform={`rotate(${angle} 32 44)`} />)}
          <ellipse cx="32" cy="50" rx="18" ry="5" fill="#3a8a5a" />
        </svg>
      )
  }
}
